export default "__VITE_ASSET__12A74fBC__"